import styled from 'styled-components';
import { TooltippedIconButton } from '@mews-commander/ui';
import { IconButtonProps } from '@optimus-web/core';

const handleIconButtonFactory =
    ({ variant, size }: Pick<IconButtonProps, 'variant' | 'size'> = {}) =>
    (props: $TSFixMe) => {
        const { title, icon, ...other } = props;

        return (
            <TooltippedIconButton
                tooltip={title}
                data-test-icon-button={icon}
                icon={icon}
                variant={variant}
                size={size}
                {...other}
            />
        );
    };
export const SmallDefaultHandleButton = handleIconButtonFactory({ variant: undefined, size: 'small' });

const HandleIconButton = styled(handleIconButtonFactory())`
    margin-right: 8px;
`;
export default HandleIconButton;
